import { useCheckResourcePermissions } from '@spotify/plugin-confidence-permissions-react';

type WorkspaceAdmin = {
  isWorkspaceAdmin: boolean;
  loading: boolean;
};

export const useIsWorkspaceAdmin = (): WorkspaceAdmin => {
  const { allowed, loading, hasData, error } = useCheckResourcePermissions({
    name: 'account',
    can: 'manage_billing',
  });
  return {
    isWorkspaceAdmin: allowed,
    loading: !error && (loading || !hasData),
  };
};
